import React, {Component, useState, useContext} from 'react';
import {BrowserRouter, Routes, Route, useLocation, Navigate} from 'react-router-dom';
import { /*RoutePrivate,*/ RouteRestricted } from './utils/routes';
import {UserContext, UserProvider} from './utils/usercontext';
import Socket from './utils/socket';
//import Donation from './routes/components/donation/donation';
//import Notifications from './routes/components/notifications/notifications';
//import Fault from './routes/components/fault/fault';

//---- Main components
import Header from './routes/header';
import Footer from './routes/footer';
import Loading from './routes/loading';

//---- User account pages
import Login from './routes/login';

//---- Pages
import SupportIndex from './routes/index';
import SupportInvoices from './routes/invoices';
import SupportWebsites from './routes/websites';
import SupportServices from './routes/services';
import SupportStreams from './routes/streams';
import SupportLogs from './routes/logs';
import SupportTemplate from './routes/template';
import SupportOutbox  from './routes/outbox';
import SupportSystem from './routes/system';
import SupportCanvas from './routes/canvas';

//import Authentication from './routes/authentication';
//import Loadout from './routes/loadout';
//import Stream from './routes/stream';
//import Template from './routes/template';

//---- Embeds
//import EmbedVideo from './routes/embed/video';


//---- CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import './routes/css/velvet.css';
import './routes/css/app.css';
import './routes/css/boxicons.css';

const ViewLogin = (props) => {
  const value = useContext(UserContext);
  if( !value.user.user ) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<Loading />} />
        </Routes>
      </BrowserRouter>
    )
  } else if( value.user?.admin ) {
    return (
      <>
        {props.children}
      </>
    )
  } else {
    return (
      <BrowserRouter>
        <Routes>
          {/*<Route path={"/video/:service"} exact element={<EmbedVideo />} />*/}
          <Route path="*" element={<Login />} />
        </Routes>
      </BrowserRouter>
    )
  }
}


function App() {
  return (
    <div className="page">
      <UserProvider>
        <ViewLogin>
          <BrowserRouter>
            <Header />
            <Routes>
              <Route path="/" exact element={<SupportIndex />} />
              <Route path="/invoices" exact element={<SupportInvoices />} />
              <Route path="/websites" exact element={<SupportWebsites />} />
              <Route path="/services" exact element={<SupportServices />} />
              <Route path="/streams" exact element={<SupportStreams />} />
              <Route path="/logs" exact element={<SupportLogs />} />
              <Route path="/template" exact element={<SupportTemplate />} />
              <Route path="/outbox" exact element={<SupportOutbox />} />
              <Route path="/system" exact element={<SupportSystem />} />
              <Route path="/canvas" exact element={<SupportCanvas />} />
              {/*<Route path={"/authentication/:application"} exact element={<Authentication />} />
              <Route path={"/:service/authentication"} exact element={<Authentication />} />
              <Route path={"/:service/loadout"} exact element={<Loadout />} />
              <Route path={"/:service/stream"} exact element={<Stream />} />
              <Route path={"/:service/template"} exact element={<Template />} />*/}
            </Routes>
            <Footer />
            <Socket />
          </BrowserRouter>
        </ViewLogin>
      </UserProvider>
    </div>
  );
}

export default App;
